import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import JoditEditor from "jodit-react";
import OrderFootNotesTable from "./components/Table";
import useFootNotes from "./hooks/useFootNotes";

export default function OrderFootNotesScreen() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    accountTypeList,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    nomeRef,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
    descricaoRef,
  } = useFootNotes();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <OrderFootNotesTable
          add={add}
          edit={edit}
          list={accountTypeList}
          deletar={showDeleteModal}
          showDelete={showDelete}
          cancelRef={cancelRef}
          closeDelete={closeDelete}
          remove={deletar}
        />

        <Modal
          onClose={() => {
            showModal(false);
          }}
          size={"6xl"}
          isOpen={show}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {accountSelected !== null
                ? "Editar Nota de Rodapé"
                : "Nova TNota de Rodapé"}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl isInvalid={error}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Nome<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  ref={nomeRef}
                  defaultValue={accountSelected?.nome}
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o nome da nota de rodapé"
                  onChange={(e) => (nomeRef.current = e.target.value)}
                  mb="24px"
                  fontWeight="500"
                  isInvalid={error}
                  size="lg"
                />
                {error && (
                  <FormErrorMessage>
                    Preencha Corretamente o Campo.
                  </FormErrorMessage>
                )}
              </FormControl>

              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mt={4}
                color={textColor}
              >
                Descrição da Nota de Rodapé<Text color={brandStars}>*</Text>
              </FormLabel>

              <JoditEditor
                ref={descricaoRef}
                value={accountSelected?.descricao}
                config={{
                  buttons: [
                    "source",
                    "|",
                    "bold",
                    "strikethrough",
                    "underline",
                    "italic",
                    "|",
                    "ul",
                    "ol",
                    "|",
                    "outdent",
                    "indent",
                    "|",
                    "font",
                    "fontsize",
                    "brush",
                    "paragraph",
                    "|",
                    "image",
                    "video",
                    "table",
                    "link",
                    "|",
                    "align",
                    "undo",
                    "redo",
                    "|",
                    "hr",
                    "eraser",
                    "copyformat",
                    "|",
                    "symbol",
                    "fullsize",
                    "print",
                    "about",
                  ],
                  buttonsXS: [
                    "bold",
                    "image",
                    "|",
                    "brush",
                    "paragraph",
                    "|",
                    "align",
                    "|",
                    "undo",
                    "redo",
                    "|",
                    "eraser",
                    "dots",
                  ],
                  readonly: false,
                }}
                onChange={(newContent) => {
                  descricaoRef.current = newContent;
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  showModal(false);
                }}
                variant="outline"
                marginRight={4}
              >
                Fechar
              </Button>
              <Button
                onClick={() => {
                  save();
                }}
                colorScheme="brand"
                isLoading={loading}
              >
                Salvar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </SimpleGrid>
    </Box>
  );
}
